var React = require('react');

function MeterNeedle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.735 2.286L58.565.599a3.072 3.072 0 0 1 3.163 3.067 3.055 3.055 0 0 1-3.155 3.057L1.73 4.846a1.28 1.28 0 0 1 .004-2.56z","fill":"currentColor","fillRule":"nonzero"}));
}

MeterNeedle.defaultProps = {"width":"62","height":"7"};

module.exports = MeterNeedle;

MeterNeedle.default = MeterNeedle;
